import { LocationDto } from "@braoshzmvavz/picnube-common";
import React from "react";
import LocationItem from "./LocationItem";
import { ScrollArea } from "@mantine/core";

export default function LocationList(props: {
  selectedLocation: LocationDto | null;
  locations: LocationDto[];
  onLocationSelected: (location: LocationDto) => void;
  onLocationSelectedForDetail: (location: LocationDto) => void;
}) {
  if (props.locations.length == 0) {
    return (
      <div className="flex flex-col h-full justify-center items-center p-8">
        <div className="text-lg">No locations found</div>
        <div className="text-sm text-grey-600">
          Press + to add a new location
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full overflow-auto">
      {props.locations.map((location) => {
        return (
          <LocationItem
            isLocationSelected={props.selectedLocation?.id === location?.id}
            location={location}
            onLocationSelected={props.onLocationSelected}
            onLocationSelectedForDetail={props.onLocationSelectedForDetail}
          ></LocationItem>
        );
      })}
    </div>
  );

  return (
    <ScrollArea
      scrollbarSize={14}
      scrollHideDelay={1500}
      type="hover"
      className="w-full h-full overflow-auto flex flex-col"
    >
      <div className="flex flex-col h-full">
        {props.locations.map((location) => {
          return (
            <LocationItem
              isLocationSelected={props.selectedLocation?.id === location?.id}
              location={location}
              onLocationSelected={props.onLocationSelected}
              onLocationSelectedForDetail={props.onLocationSelectedForDetail}
            ></LocationItem>
          );
        })}
      </div>
    </ScrollArea>
  );
}
